import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function ResetLinkSent() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const email = params.get('email');
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-lg shadow p-6 max-w-md w-full text-center">
        <h1 className="text-xl font-semibold text-gray-900 mb-2">Check your email</h1>
        <p className="text-sm text-gray-600">
          {email ? (
            <>If an account exists for <span className="font-medium">{email}</span>, we sent a password reset link. Please check your inbox and spam folder.</>
          ) : (
            <>If an account exists for your email, we sent a password reset link. Please check your inbox and spam folder.</>
          )}
        </p>
        <div className="mt-4 flex items-center justify-center gap-3">
          <Link to="/login" className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-indigo-500">Return to sign in</Link>
          <a href="mailto:support@sen-education.co.uk" className="text-sm text-gray-600 hover:text-gray-900">Need help?</a>
        </div>
      </div>
    </div>
  );
}

